<template>
  <div v-if="landingPage && registrationPage" class="reg-body">
    <div
      class="main-image-wrapper"
      :style="'background-image: url(' + landingPage.coverImage.imageURL + ');background-color:'+landingPage.themeColor+';'"
    >
      <div class="main-image-grad"></div>
    </div>
    <form v-if="form" @submit.prevent="sendForm()">
      <div
        class="form-header"
        :style="`background-color: ${landingPage.themeColor}`"
      >
        <h1>{{ registrationPage.title }}</h1>
      </div>
      <div
        class="sponsership"
        v-for="(sponsorship, i) in registrationPage.sponsorshipOptions"
        :key="i + 'sponsership'"
      >
        <div class="product-price">
          <b>${{ numberWithCommas(sponsorship.amount) }} </b>
          <p style="font-size: 14px; color: grey">{{ sponsorship.title }}</p>
        </div>
        <div class="product-description" v-html="sponsorship.description">
          <b style="font-size: 14px">{{}}</b>
          <p style="font-size: 13px; font-weight: light">
            {{ sponsorship.features }}
          </p>
        </div>
      </div>
      <!-- <p>Items with an asterisk (*) are required fields</p> -->
      <!-- <router-link to="/">I'm Already Registered</router-link> -->
      <label>
        Sponsorship Level
        <select class="w-input big-input" v-model="donation.amount">
          <option value="" hidden>Sponsorship Level</option>
          <option
            v-for="(sponsorship, i) in registrationPage.sponsorshipOptions"
            :key="i + 'sponsorship'"
            :value="sponsorship.amount"
          >
            {{ sponsorship.title }} - ${{
              numberWithCommas(sponsorship.amount)
            }}
          </option>
        </select>
      </label>
      <div v-for="(field, i) in registration" :key="i">
        <!-- <h3>{{ group.title }}</h3> -->

        <label
          v-if="
            field.slug != 'amount' &&
            field.slug != '_metadata' &&
            field.slug != 'paid'"
        >
          {{ field.name }}
          <input
            :class="[field.type != 8 ? 'w-input  big-input' : 'big-checkbox']"
            @input="logItem($event, field.slug)"
            :type="field.type === 8 ? 'checkbox' : 'text'"
            :placeholder="field.name"
            :v-model="form[field.slug]"
            :required="field.required"
          />
        </label>
      </div>
      <input
        v-model="donation.amount"
        name="amount"
        type="number"
        required="true"
        hidden
      />

      <br />
      <stripe
          @approve="CCApprove()"
          :donation="donation"
          :address="donation.address"
          :fullName="donation.firstName +' ' +donation.lastName"
          :amount="donation.amount"
          :email="donation.email"
          :description="registrationPage.donationDescription
"
      />
      <p style="text-align: center"><br />- or -<br /></p>
      <input class="button" type="submit" :value="status" />
    </form>
  </div>
</template>

<script>
import Bagel from "@bageldb/bagel-db";
import stripe from "../components/stripe";
export default {
  components: { stripe },
  watch: {
    donation: {
      deep: true,
      handler() {
        if (this.donation.amount < 0) this.donation.amount = 0;
      },
    },
  },
  methods: {
    logItem(event, slug) {
      this.donation[slug] = event.target.value;
    },
    setAmount(i) {
      this.donation.amount = this.sponsershipTiers[i].amount;
    },
    CCApprove() {
      this.donation.paid = true;
      this.sendForm();
    },
    async sendForm() {
      this.status = "sending...";
      // let token = tokens.find((t) => t.siteURL == this.site).token;

      await this.db.collection("registrationPage").item("5fa432abad1603b569e90e93").collection("registrations").post(this.donation);
      this.$router.push("/");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  async mounted() {
    this.db = new Bagel(process.env.VUE_APP_BAGEL_TOKEN);
    this.db
      .collection("landingPage")
      .get()
      .then(({ data }) => (this.landingPage = data[0]));
    this.db
      .collection("registrationPage")
      .item("5fa432abad1603b569e90e93")
      .get()
      .then(({ data }) => (this.registrationPage = data));
    this.db
      .schema("registrationPage")
      .get()
      .then(({ data }) => {
        let registrations = data.find((i) => i.slug == "registrations");
        let form = {};
        this.registration = registrations.nestedCollectionSchema;
        for (const field of this.registration) {
          form[field.slug] = "";
        }
        this.form = form;
      });
  },
  data() {
    return {
      db: null,
      registrationPage: null,
      landingPage: null,
      donation: {
        firstName: "",
        lastName: "",
        emailAddress: "",
        streetAddress: "",
        state: "",
        city: "",
        zipCode: "",
        phoneNumber: "",
        amount: "",
        paid: false,
      },
      openAmount: false,
      selectedSponsership: "",
      form: false,
      status: "Bill Me Later",
      registration: [],
    };
  },
};
</script>

<style scoped>
.product-price {
  display: inline-block;
  width: 20%;
  vertical-align: top;
  margin-top: 10px;
}
.product-description {
  display: inline-block;
  width: 77%;
}
.form-header {
  border-radius: 10px;
  margin-bottom: 20px;
  color: white;
  padding: 10px 20px 18px;
}
.big-input {
  font-weight: 300;
  height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  border: 1px solid #c8cdd2;
  font-size: 18px;
  color: #6d7a83;
  -webkit-appearance: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.big-input:focus {
  border-color: #563d7c;
}
.big-checkbox{
  float: left;
  margin-top: 5px;
  border-radius: 10px;
  width: 30px;
  height: 13px;
}
.main-image-wrapper {
  height: 250px;
  background-size: contain;
  background-repeat: no-repeat;
}
.tooltip::after {
  content: "";
  display: block;
  height: 10px;
  width: 10px;
  background: white;
  position: absolute;
  top: -6px;
  transform: rotate(45deg);
}
.tooltip {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 105%;
  background: white;
  padding: 20px 10px 20px 20px;
  box-shadow: 1px 1px 20px lightgray;
  z-index: 2;
  border-radius: 2px;
  width: 50%;
  opacity: 0;
  transition: all ease 0.3s;
}
.sponsership {
  position: relative;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 10px 20px;
  margin-top: 20px;
  overflow: hidden;
  transition: ease-in-out all 0.2s;
}

.sponsership b {
  font-size: 22px;
}
.sponsership:hover {
  overflow: visible;
}
.sponsership:hover .tooltip {
  opacity: 1;
}
.sponsership.active {
  border-color: rgb(41, 179, 102);
}
.active b {
  color: rgb(41, 179, 102);
}
.reg-body {
  min-height: 100vh;
  text-align: left;
}
form {
  margin: auto;
  background: #eeeeee;
  display: block;
  padding: 40px;
  max-width: 870px;
  width: 95%;
  margin-top: 200px;
  position: relative;
  z-index: 3;
  border-radius: 5px;
}
.w-button {
  border-radius: 100px;
  padding: 7px 40px;
  display: inline-block;
}
@media screen and (max-width: 768px) {
  form {
    width: 100%;
    border-radius: 0;
    margin-top: 120px;
  }
  .product-price {
    display: block;
    width: auto;
  }
  .product-description {
    display: block;
    width: auto;
  }
  .main-image-wrapper {
    height: 120px;
  }
}

.big-input:focus::-webkit-input-placeholder {
  -webkit-transform: translateX(8%);
  transform: translateX(8%);
  opacity: 0;
}

.big-input::-webkit-input-placeholder {
  transition: all ease 0.4s;
}
</style>